import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/icons/sort.svg'
import _imports_1 from '@/assets/images/user-placeholder.jpg'
import _imports_2 from '../../../assets/icons/heart-icon.svg'
import _imports_3 from '@/assets/images/project-request-empty.png'


const _withScopeId = n => (_pushScopeId("data-v-2a293b8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "historic_project"
}
const _hoisted_2 = {
  key: 0,
  class: "content_field tw-mb-4"
}
const _hoisted_3 = { class: "sort__wrapper sort_dropdown_wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sortby_btn" }, "Sort by", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_6 = {
  key: 1,
  class: "historic_project__card_list md:!tw-mt-0"
}
const _hoisted_7 = { class: "card__header" }
const _hoisted_8 = { class: "card__header__img" }
const _hoisted_9 = {
  key: 0,
  class: "",
  src: _imports_1
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "right__block" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heart_icon" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1))
const _hoisted_13 = { class: "card__content" }
const _hoisted_14 = { class: "card__content__header" }
const _hoisted_15 = { class: "card__info" }
const _hoisted_16 = { class: "card__info__left" }
const _hoisted_17 = { class: "card__info__right" }
const _hoisted_18 = { class: "card__info__tags" }
const _hoisted_19 = { class: "card__info__tags__default" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Exp.", -1))
const _hoisted_21 = {
  key: 0,
  class: "card__info__tags__custom"
}
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 0,
  class: "custom_tags__more"
}
const _hoisted_24 = { class: "card_project_summary" }
const _hoisted_25 = { class: "card_project_summary__list" }
const _hoisted_26 = { class: "card_project_summary__list_item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Start Date", -1))
const _hoisted_28 = { class: "card_project_summary__list_item" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Duration", -1))
const _hoisted_30 = { class: "card_project_summary__list_item" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Cost", -1))
const _hoisted_32 = { class: "card__footer" }
const _hoisted_33 = {
  key: 2,
  class: "empty-screen md:!tw-pt-[24px] md:!tw-mt-0"
}
const _hoisted_34 = { class: "empty-screen__inner" }
const _hoisted_35 = /*#__PURE__*/_createStaticVNode("<div class=\"empty-screen__image md:!tw-ml-0 md:!tw-mb-[24px]\" data-v-2a293b8e><img src=\"" + _imports_3 + "\" alt=\"\" data-v-2a293b8e></div><div class=\"empty-screen__header\" data-v-2a293b8e><h2 data-v-2a293b8e>You currently don&#39;t have any project requests.</h2><p data-v-2a293b8e>Kick off your historic project with unparalleled speed.</p></div><div class=\"empty-screen__content\" data-v-2a293b8e><div class=\"empty-screen__content-item\" data-v-2a293b8e><div class=\"mdi mdi-check-circle\" data-v-2a293b8e></div><p data-v-2a293b8e><strong data-v-2a293b8e>Dispute protection</strong> as standard</p></div><div class=\"empty-screen__content-item\" data-v-2a293b8e><div class=\"mdi mdi-check-circle\" data-v-2a293b8e></div><p data-v-2a293b8e>Deposits secured <strong data-v-2a293b8e>in Escrow</strong></p></div><div class=\"empty-screen__content-item\" data-v-2a293b8e><div class=\"mdi mdi-check-circle\" data-v-2a293b8e></div><p data-v-2a293b8e> Verified trade contractors <strong data-v-2a293b8e>in your local area</strong></p></div></div>", 3)
const _hoisted_38 = { class: "empty-screen__footer" }

import { onBeforeRouteLeave, useRouter } from "vue-router";
import { PROJECT_REQUESTED_DETAILS_ROUTE } from "../routes";
import Text from "@/core/uni-components/Text.vue";
import InputField from "@/core/uni-components/InputField.vue";
import ProjectRequestedCard from "@/modules/project/components/common/ProjectRequestedCard.vue";
import { PROJECT_ROUTE } from "../routes";
import { computed } from "vue";
import { useStore } from "vuex";
import { PROJECT_STORE } from "@/store/modules/project";
import { onMounted, ref, reactive, onBeforeUnmount, watch } from "vue";
import { debounce } from "lodash";
import CommonLoader from "@/core/components/CommonLoader.vue";
import estimatesBannerSvg from "@/core/uni-assets/svgs/estimates-banner.svg";
import { EstimateTypeForDeposit } from "@/core/enums/estimateEnum";
import { BusinessDetailTypeEnum } from "@/core/enums/RolesEnum";
import {
  getImageStringToImageURL,
  getUserSubSkillList,
} from "@/core/utils/common";
import { USER_STORE } from "@/store/modules/user";
import { WORKSTATION } from "@/store/modules/workstation";
import moment from "moment";
import currencyFilter from "@/filters/currency.filter";
import { watchEffect } from "vue";
import EstimateBadge from "@/core/uni-components/EstimateBadge.vue";
import PropertyListComponent from "./PropertyListComponent.vue";
import Loader from "@/core/components/common/Loader.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectRequestedComponent',
  setup(__props) {

const store = useStore();
const router = useRouter();
const loading = ref(false);
const showBanner = ref(true);
const showProjectDetails = ref(false);
const getProjectRequestedList = computed(
  () => store.getters[`${PROJECT_STORE}/getProjectRequestedList`]
);
const isOpenNewProject = ref(false);

const filters = reactive({
  search: "",
  sortBy: "ASC",
}) as any;
const contractorsImages: any = ref({});
const viewProject = async (refId: string, projectId: number) => {
  if (refId) {
    router.push({
      name: PROJECT_REQUESTED_DETAILS_ROUTE,
      params: { refId: refId },
    });
  }
};

watch(
  filters,
  (state: any) => {
    let params = JSON.parse(JSON.stringify({ ...state }));
    if (!params.search.length) {
      delete params["search"];
    }

    if (!getProjectRequestedList.value.length) return;
    fetchProjects(params);
  },
  { deep: true }
);
const fetchProjects = debounce(async (params) => {
  try {
    loading.value = true;
    await store.dispatch(`${PROJECT_STORE}/fetchAllRequestedProjects`, params);
  } catch (error) {
    console.log("error", error);
  } finally {
    loading.value = false;
  }
}, 500);
const activeUserWorkstation = computed(
  () => store.getters[`${WORKSTATION}/activeUserWorkstation`]
);
const getAllSpecialism = computed(
  () => store.getters[`${USER_STORE}/getAllSpecialism`]
);
const getUserSkillList = (userSkill: any) => {
  return getUserSubSkillList(userSkill, getAllSpecialism.value);
};
const getEstimateBadge = (project: any) => {
  let selectedEstimate = project?.projectEstimation;
  if (Array.isArray(project.projectEstimation)) {
    selectedEstimate = project?.projectEstimation[0];
  }

  if (selectedEstimate?.depositType === EstimateTypeForDeposit.Initial_Estimate)
    return "Initial Estimate";
  else if (
    selectedEstimate?.depositType ===
    EstimateTypeForDeposit.Fixed_Cost_Estimation
  )
    return "Fixed Cost Estimation";
  else if (
    selectedEstimate?.depositType ===
    EstimateTypeForDeposit.Variable_Cost_Estimation
  )
    return "Variable Cost Estimation";
  else return "";
};
const duration = (suggestedStartDate: string, suggestedEndDate: string) => {
  if (!suggestedStartDate || !suggestedEndDate) return 0;
  const startDate = moment(suggestedStartDate);
  const endDate = moment(suggestedEndDate);

  const totalDays = endDate.diff(startDate, "days");
  const totalWeeks = endDate.diff(startDate, "weeks");

  let result;

  if (totalDays % 7 === 0) {
    result = `${totalWeeks} week${totalWeeks !== 1 ? "s" : ""}`;
  } else {
    result = `${totalDays} day${totalDays !== 1 ? "s" : ""}`;
  }

  return result;
};
const formattedCurrency = (amount: any) => {
  return currencyFilter.formatToCurrency(amount);
};

const setProfileImageUrl = async (proj: any) => {
  for (const projectCreator of proj) {
    if (projectCreator?.userWorkStation?.userPublicProfile?.profileImage) {
      contractorsImages.value[projectCreator.id] =
        await getImageStringToImageURL(
          projectCreator.userPublicProfile.profileImage
        );
    }
  }
};

watchEffect(async () => {
  await setProfileImageUrl(getProjectRequestedList.value);
});
onMounted(async () => {
  let params = JSON.parse(JSON.stringify({ ...filters }));
  if (!params.search.length) delete params["search"];
  await fetchProjects(params);
});

onBeforeUnmount(async () => {
  if (!getAllSpecialism.value.length) {
    await store.dispatch(
      `${USER_STORE}/setAllSpecialismsCategory`,
      activeUserWorkstation.value.id
    );
  }
  store.dispatch(`${PROJECT_STORE}/resetAllRequestedProjects`, []);
});

const openNewProject = () => {
  isOpenNewProject.value = true;
};
const onClickBackButton = () => {
  isOpenNewProject.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!showProjectDetails.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (getProjectRequestedList.value.length && !loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_v_text_field, {
                  "prepend-inner-icon": "mdi-magnify",
                  class: "input_field",
                  placeholder: "Search",
                  variant: "outlined",
                  modelValue: filters.search,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.search) = $event))
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createVNode(_component_v_menu, {
                    "close-on-content-click": false,
                    persistent: true
                  }, {
                    activator: _withCtx(({ props }) => [
                      _createVNode(_component_v_btn, _mergeProps(props, {
                        class: "sort__btn",
                        variant: "plain"
                      }), {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 2
                      }, 1040)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list, { class: "dropdown__sort sort_dropdown_inner" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_radio_group, {
                                modelValue: filters.sortBy,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.sortBy) = $event))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_radio, {
                                    label: "Most Recent",
                                    value: "ASC",
                                    color: "indigo"
                                  }),
                                  _createVNode(_component_v_radio, {
                                    label: "Oldest",
                                    value: "DESC",
                                    color: "indigo"
                                  })
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (!loading.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getProjectRequestedList.value, (item) => {
                  return (_openBlock(), _createBlock(_component_v_card, {
                    key: item.id,
                    class: "historic_project__card__item"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                          (!contractorsImages.value[item?.id])
                            ? (_openBlock(), _createElementBlock("img", _hoisted_9))
                            : (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                class: "",
                                src: contractorsImages.value[item?.id]
                              }, null, 8, _hoisted_10))
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createVNode(EstimateBadge, {
                            badge: getEstimateBadge(item),
                            bgColor: "#C19F5F"
                          }, null, 8, ["badge"]),
                          _hoisted_12
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("h5", null, _toDisplayString(item?.userWorkStation?.user?.firstName) + " " + _toDisplayString(item?.userWorkStation?.user?.lastName), 1),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("span", null, _toDisplayString(_unref(BusinessDetailTypeEnum).SOLETRADER ===
                    item?.userWorkStation?.user?.userBusinessDetails?.type
                      ? "Solo Trader"
                      : "Limited Company") + " | ", 1),
                              _createElementVNode("span", null, [
                                _createVNode(_component_v_icon, {
                                  icon: "mdi-map-marker",
                                  size: "x-small"
                                }),
                                _createTextVNode(" " + _toDisplayString(item?.userWorkStation?.user?.postcode || "NA"), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_17, [
                              _createVNode(_component_v_icon, {
                                icon: "mdi-star",
                                color: "#FFA500"
                              }),
                              _createElementVNode("span", null, _toDisplayString(item?.ratings) + "/5 (" + _toDisplayString(item?.jobsCompleted) + " Jobs)", 1)
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createVNode(_component_v_icon, {
                              icon: "mdi-check-circle",
                              color: "#1fb27a"
                            }),
                            _createElementVNode("p", null, [
                              _createTextVNode(_toDisplayString(item?.userWorkstation?.experience || "NA") + " ", 1),
                              _hoisted_20
                            ])
                          ]),
                          (
                item?.userWorkstation?.user?.userSkills &&
                item?.userWorkstation?.user.userSkills.length
              )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getUserSkillList(
                  item.projectCreator?.userSkills
                ).slice(0, 1), (skill) => {
                                  return (_openBlock(), _createElementBlock("div", {
                                    class: "custom_tags",
                                    key: skill.id
                                  }, [
                                    _createVNode(_component_v_icon, null, {
                                      default: _withCtx(() => [
                                        (skill?.iconName)
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              src: 
                      require('@/assets/category-icons/' +
                        skill?.iconName +
                        '.svg')
                    
                                            }, null, 8, _hoisted_22))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createElementVNode("span", null, _toDisplayString(skill?.label), 1)
                                  ]))
                                }), 128)),
                                (
                  getUserSkillList(item.projectCreator?.userSkills).length > 1
                )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                      _createElementVNode("span", null, " +" + _toDisplayString(getUserSkillList(item.projectCreator?.userSkills).length - 1) + " More ", 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _hoisted_27,
                              _createElementVNode("span", null, _toDisplayString(_unref(moment)(item?.projectEstimation?.suggestedStartDate).format(
                      "DD MMMM YYYY"
                    )), 1)
                            ]),
                            _createElementVNode("div", _hoisted_28, [
                              _hoisted_29,
                              _createElementVNode("span", null, _toDisplayString(duration(
                      item?.projectEstimation?.suggestedStartDate,
                      item?.projectEstimation?.suggestedEndDate
                    )), 1)
                            ]),
                            _createElementVNode("div", _hoisted_30, [
                              _hoisted_31,
                              _createElementVNode("span", null, _toDisplayString(formattedCurrency(
                      item?.projectEstimation?.totalEstimateCost
                    )), 1)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _createVNode(_component_v_btn, {
                          class: "button button-orange",
                          width: "100%",
                          onClick: ($event: any) => (viewProject(item?.refId, item?.projectEstimateId))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("View Project")
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (!getProjectRequestedList.value.length && !loading.value && !isOpenNewProject.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_v_btn, {
                      class: "button button-purple",
                      onClick: openNewProject,
                      block: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Start a new project ")
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode(Loader, { class: "tw-mt-[250px]" }, null, 512), [
            [_vShow, loading.value]
          ])
        ]))
      : _createCommentVNode("", true),
    (isOpenNewProject.value)
      ? (_openBlock(), _createBlock(PropertyListComponent, {
          key: 1,
          onOnClickBackButton: onClickBackButton
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})